import {sessionCheck} from "../components/api.svelte";


export const getLocalSessionId = () => {

    return localStorage.getItem('sid');
};

export let sessionCleanup = () => {

    localStorage.removeItem('sid');
};

export const checkLocalSession = (router) => {

    console.log('checkLocalSession')

    if (getLocalSessionId()) {

        sessionCheck().then((sessionVerified) => {

            if (!sessionVerified) {

                sessionCleanup();
                router.route('/login')

            }

        });

        return;

    }

    sessionCleanup();
    router.route('/login')

};

export const checkUnauthorized = (router, result) => {

    if (result['reason'] === 'unauthorized') {

        sessionCleanup();
        router.route('/login');

        return true;

    }

    return false;

};